import toggleClass from './toggleClass';

export default function () {
  toggleClass({ elId: 'js-header-sceen', className: 'active' });
  toggleClass({ elId: 'js-document-wrapper', className: 'active' });
  toggleClass({ elId: 'js-nav', className: 'active' });
  toggleClass({ elId: 'js-header', className: 'active' });
  toggleClass({ elId: 'js-logout-button', className: 'active' });
}



// WEBPACK FOOTER //
// ./src/theme/dom/toggleNavigation.js